module.exports = __webpack_public_path__ + "static/media/360-guide-mobile.3bffcafa.png";